import { Route } from "react-router-dom";

import { routes } from "constants/routes";
import UserSettings from "features/main/UserSettings";
import UserAccount from "features/main/UserSettings/Account";
import UserBilling from "features/main/UserSettings/Billing";
import BillingReceipt from "features/main/UserSettings/Billing/BillingReceipt";
import Help from "features/main/UserSettings/Help";
import UserNotifications from "features/main/UserSettings/Notifications";
import UserSettingProfile from "features/main/UserSettings/Profile";
import Theme from "features/main/UserSettings/Theme";
import { useSelector } from "react-redux";
import API from "../../features/main/UserSettings/API";
import { RootState } from "store";

export default function SettingsRoutes() {
  const { userDetails } = useSelector((state: RootState) => state.userState);
  return (
    <Route path={routes.SETTINGS}>
      <Route index element={<UserSettings />} />
      <Route path={routes.SETTINGS_ACCOUNT} element={<UserAccount />} />
      <Route path={routes.SETTINGS_PROFILE} element={<UserSettingProfile />} />
      <Route path={routes.SETTINGS_NOTIFICATIONS} element={<UserNotifications />} />
      <Route path={routes.SETTINGS_BILLING} element={<UserBilling />} />
      <Route path={routes.SETTINGS_BILLING_RECEIPT} element={<BillingReceipt />}></Route>
      <Route path={routes.SETTINGS_HELP} element={<Help />} />
      <Route path={routes.SETTINGS_THEME} element={<Theme />} />
      {userDetails?.tms_external_api_access && (
        <Route path={routes.SETTINGS_API} element={<API />} />
      )}
    </Route>
  );
}
